import { useContext, useEffect } from "react";
import { Form, Button, Card } from "react-bootstrap";
import { PersonFill, Calendar, Save, Trash, XCircle, ArrowRight, Tools } from "react-bootstrap-icons";
import { InfraccionesContext } from "../context/InfraccionesContext";
import { fetchCurrentUser } from "../services/api";
import { getStoredUser, setSessionData } from "../utils/session";
import "./infracciones.css";

export default function Infracciones({ setActivePage }) {
    const { form, setForm } = useContext(InfraccionesContext);

    useEffect(() => {
        async function obtenerNombreAgente() {
            const localUser = getStoredUser();
            if (localUser?.nombre) {
                setForm((prevForm) => {
                    if (prevForm.agente === localUser.nombre) {
                        return prevForm;
                    }

                    return {
                        ...prevForm,
                        agente: localUser.nombre
                    };
                });
                return;
            }

            try {
                const userData = await fetchCurrentUser();
                if (userData?.nombre) {
                    setForm((prevForm) => {
                        if (prevForm.agente === userData.nombre) {
                            return prevForm;
                        }

                        return {
                            ...prevForm,
                            agente: userData.nombre
                        };
                    });
                    setSessionData(userData);
                }
            } catch (error) {
                console.warn("No se pudo obtener el agente en sesion:", error);
            }
        }

        obtenerNombreAgente();
    }, [setForm]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleClear = async () => {
        if (window.confirm("¿Estás seguro de que deseas limpiar todos los campos?")) {
            const nombreAgente = getStoredUser()?.nombre || "";

            setForm((prevForm) => ({
                ...prevForm,
                agente: nombreAgente,
                serieEquipo: "20252027",
                fecha: new Date().toISOString().split("T")[0],
            }));
        }
    };

    const handleNext = () => {
        setActivePage("motivacion");
    };

    const handleSave = () => {
        alert("Datos guardados temporalmente.");
    };

    return (
        <div className="container">
            <h1 className="title">Registro de Infracciones</h1>
            <div className="divider"></div>

            <Card className="info-card mb-6" style={{ backgroundColor: "#ffcccc" }}>
                <p>Los campos con asterisco (*) son obligatorios</p>
            </Card>

            <Form className="form-container">
                <Card className="mb-6 p-4">
                    <Form.Group className="row">
                        {[{
                            label: "Agente *", name: "agente", icon: <PersonFill />, placeholder: "Agente"
                        },
                        {
                            label: "Serie del equipo *", name: "serieEquipo", icon: <Tools />, placeholder: "Serie del Equipo"
                        },
                        {
                            label: "Fecha *", name: "fecha", icon: <Calendar />, placeholder: "Fecha"
                        }].map((field, index) => (
                            <div key={index} className="col-md-4">
                                <div className="custom-form-group">
                                    <label className="form-label">{field.label}</label>
                                    <div className="input-group">
                                        {field.icon && <span className="input-icon">{field.icon}</span>}
                                        <Form.Control
                                            type={field.name === "fecha" ? "date" : "text"}
                                            placeholder={field.placeholder}
                                            name={field.name}
                                            value={form[field.name]}
                                            onChange={handleChange}
                                            required={field.label.includes("*")}
                                            maxLength={field.name === "serieEquipo" ? 13 : undefined}
                                            disabled={["agente", "serieEquipo"].includes(field.name)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Form.Group>
                </Card>

                <div className="button-group">
                    <Button type="button" variant="primary" className="mr-2" onClick={handleSave}><Save /> Guardar</Button>
                    <Button type="button" variant="success" className="mr-2" onClick={handleNext}><ArrowRight /> Siguiente</Button>
                    <Button type="button" variant="secondary" className="mr-2" onClick={handleClear}><Trash /> Limpiar</Button>
                    <Button type="button" variant="danger" onClick={handleClear}><XCircle /> Cancelar</Button>
                </div>
            </Form>
        </div>
    );
}
